import React, { useState } from "react";
import { ArrowUp, ArrowDown } from "lucide-react";
import Export from "../../assets/dashboard/export.svg";

const IndrustryEngagement = () => {
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [keyword, setKeyword] = useState("");

  const data = [
    {
      id: 1,
      Industry: "Healthcare & Life Sciences",
      Percentage: 25.0,
      rate: 0,
    },
    {
      id: 2,
      Industry: "Financial Services & FinTech",
      Percentage: 22.5,
      rate: 5,
    },
    {
      id: 3,
      Industry: "Information Technology & Software",
      Percentage: 19.0,
      rate: -5,
    },
    {
      id: 4,
      Industry: "Manufacturing & Industrial Goods",
      Percentage: 17.5,
      rate: 5,
    },
    {
      id: 5,
      Industry: "Consumer Retail & E-commerce",
      Percentage: 15.0,
      rate: -5,
    },
  ];

  return (
    <div className="border border-gradient-04 rounded-2xl p-2 md:p-4 shadow-sm bg-white">
      {/* Header */}
      <div className="flex justify-between items-centermb-4 border-b border-black-40">
        <h2 className="font-bold text-lg text-black-800 uppercase">
          Top Industry Engagement
        </h2>
        <button className="p-3 mb-2 bg-black-0 hover:bg-black-20 focus:bg-black-40 border-2 border-black-600 rounded group relative">
          <img src={Export} alt="Export" />
          <div className="absolute top-12 left-1/2 -translate-x-1/2 mr-2 px-2 py-1 bg-gray-800 text-white text-xs shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-nowrap uppercase">
            Export
            <div className="absolute left-1/2 bottom-full border-4 border-transparent border-b-gray-800"></div>
          </div>
        </button>
      </div>

      <div className="space-y-4 mb-4 mt-2">
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Industry
          </label>
          <select className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-50 focus:outline-none cursor-pointer">
            <option>Select</option>
          </select>
        </div>
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Keyword
          </label>
          <input
            type="text"
            placeholder="Write the keyword"
            className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-600 placeholder:text-black-50 focus:outline-none"
          />
        </div>
      </div>

      {/* Table Header */}
      <div className="grid grid-cols-[0.5fr,3fr,1fr,1fr] md:grid-cols-[0.5fr,3fr,1fr,1fr] gap-4 text-sm md:text-xl font-bold text-black-600 text-left pb-2 border-b">
        <div>#</div>
        <div>Industry</div>
        <div className="text-center">%</div>
        <div className="text-center">last month</div>
      </div>

      {/* Table Rows */}
      {data.map((item) => (
        <div
          key={item.id}
          className="grid grid-cols-[0.5fr,3fr,1fr,1.5fr] items-center gap-4 py-3 border-b border-gray-100 last:border-b-0 text-lg text-black-600"
        >
          <div className="font-medium">{item.id}</div>
          <div>{item.Industry}</div>
          <div className="text-right font-medium">
            {item.Percentage.toFixed(1)}
          </div>
          <div className="flex items-center justify-end font-semibold">
            {item.rate !== 0 && (
              <span
                className={`text-sm mr-1 ${
                  item.rate > 0 ? "text-green-500" : "text-red-500"
                }`}
              >
                {item.rate > 0 ? <ArrowUp size={16} /> : <ArrowDown size={16} />}
              </span>
            )}
            <span
              className={`${
                item.rate > 0
                  ? "text-green-500"
                  : item.rate < 0
                  ? "text-red-500"
                  : "text-gray-500"
              }`}
            >
              {item.rate !== 0 ? `${Math.abs(item.rate)}%` : "—"}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default IndrustryEngagement;
